import Reac, { useState } from "react";
import Navigation from "../components/Navigation";
import FundosConsolidado from "../components/data/FundosConsolidado";
import { useKeycloak } from "@react-keycloak/web";

const ExtratoConsolidado = () => {
  const { keycloak } = useKeycloak();
  
  const [nif, setNif] = useState(
    getSessionNif()
  );

  function getSessionNif() {
    const stored = sessionStorage.getItem('nifAdmin');

    try 
    {
      if (stored)
      {
        return JSON.parse(stored);
      }
      else
      {
        return keycloak.tokenParsed.preferred_username;
      }
    }
    catch
    {
      return keycloak.tokenParsed.preferred_username;
    }
  }

 return (
  <div className="container-fluid mt-4 mb-3">
    <div className="row gx-3"  style={{justifyContent: 'space-around'}}>
      <div className="col-md-2" style={{maxWidth:'250px'}}>
        <Navigation activeKey="/extratoconsolidado" />
      </div>
      <div className="col-md-10">
        <h1 className="mt-4">Carteira</h1>
        <h2 className="mb-4">Extrato consolidado</h2>
        <FundosConsolidado nif={nif} />
        <div className="col-md-12 bg-white rounded-4 p-3">
          <p className="ms-1" style={{fontSize:'11px', textAlign:'justify', color:'#666666'}}>
            O valor da unidade de participação (UP) dos Fundos de Pensões evolui, em cada momento, em função do valor dos ativos integrantes da carteira do Fundo, pelo que pode aumentar ou diminuir, sendo o respetivo valor divulgado diariamente, nos dias úteis.<br />
            Os valores apresentados foram calculados com base nas UP diárias do Fundo, que refletem o potencial de valorização dos ativos subjacentes e o valor atual dos rendimentos futuros.<br />
            O valor da UP é líquido de comissões e impostos na esfera do Fundo, estando o investidor sujeito à aplicação das comissões contratualizadas, nomeadamente comissão de reembolso ou de subscrição caso tal se aplique, bem como à fiscalidade inerente a este produto a título de imposto sobre os rendimentos das pessoas singulares.<br />
            Os Fundos de Pensões encontram-se isentos de imposto sobre o rendimento, exceto na situação prevista no n.º11 do art.º 88.º do Código do IRC. Por regra, os participantes são tributados no momento do reembolso, por retenção na fonte.<br />
            Os Documentos Constitutivos dos Fundos de Pensões encontram-se disponíveis em na área: Extrato Individual &gt; Informação sobre o Fundo.<br />
            Caso cesse o vínculo laboral, o valor associado aos direitos adquiridos poderá diferir do apresentado, de acordo com as regras do plano de Pensões.<br />
            Os valores apresentados são referentes à situação financeira específica do Participante.<br />
            A CGD PENSÕES, Sociedade Gestora de Fundos de Pensões, S.A., não é responsável pela realização das contribuições a cargo do Associado.
          </p>
        </div>
      </div>
    </div>
  </div>
 );
};

export default ExtratoConsolidado;
